import { Box, Card, Heading, Paragraph, TextButton } from '@zillow/constellation-10';

const CityscapeIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 108 108" fill="none">
    <path
      d="M108 62.0935C108 42.7054 99.8331 0 67.7971 0C46.1214 0 34.2607 14.7528 19.4014 25.6802C4.27801 36.8021 0 46.7834 0 62.6983C0 83.119 14.3021 108 51.5743 108C88.8465 108 108 92.124 108 62.0935Z"
      fill="#FFF0E1"
    />
    <path
      d="M31.3558 36.5664V70.9201H13.8633V53.6563V42.3617L18.6274 38.8808V31.1297H22.9959L25.6927 34.3211V36.5653H31.3569L31.3558 36.5664ZM76.9782 37.6324V26.5537H65.1347V35.0177H59.7648V57.095H54.5458V36.5999H45.5404V30.2095H44.8484V36.5999H35.8429V87.2746H38.5947V105.574H67.5933V93.1973H82.3599V54.3248V37.7404L76.9771 37.6324H76.9782ZM103.064 51.6022H100.101V43.6231H91.6198L88.1307 48.1624V51.6032H84.9575L84.5954 77.5535H88.1307V83.3887H100.1V77.5535H102.701L103.063 51.6032L103.064 51.6022Z"
      fill="#FFD3C2"
    />
    <path
      d="M21.9409 37.5235H20.1074V34.777H21.9409V37.5235ZM21.9409 39.7537H20.1074V42.5001H21.9409V39.7537ZM21.9409 44.7314H20.1074V47.4778H21.9409V44.7314ZM25.3609 44.7314H23.5275V47.4778H25.3609V44.7314ZM21.9409 49.7091H20.1074V52.4555H21.9409V49.7091ZM49.9058 52.7439H51.7392V49.9975H49.9058V52.7439ZM46.4858 47.7673H48.3192V45.0208H46.4858V47.7673ZM49.9058 42.7895H51.7392V40.0431H49.9058V42.7895ZM42.9515 57.7216H44.7849V54.9752H42.9515V57.7216ZM42.9515 52.7439H44.7849V49.9975H42.9515V52.7439ZM42.9515 42.7895H44.7849V40.0431H42.9515V42.7895ZM71.5103 36.0989H73.582V32.9961H71.5103V36.0989ZM67.6462 36.0989H69.7179V32.9961H67.6462V36.0989ZM71.5103 41.7214H73.582V38.6186H71.5103V41.7214ZM67.6462 47.345H69.7179V44.2421H67.6462V47.345ZM71.5103 52.9685H73.582V49.8657H71.5103V52.9685ZM91.2782 51.7157H93.3498V48.6129H91.2782V51.7157ZM94.9343 55.5767H97.0059V52.4739H94.9343V55.5767Z"
      fill="#FFA385"
    />
    <path
      d="M75.1535 105.31V69.0395H65.1694L59.4093 75.9644V81.736H56.913V61.729H55.5689V60.0215H34.6413V61.729H32.3379V98.976H55.7618V107.931C62.9588 107.689 69.4254 106.81 75.1535 105.31Z"
      fill="#0041D9"
    />
    <path
      d="M66.5998 77.2924V75.0362H67.7995V77.2924H66.5998ZM64.8311 75.0352V77.2913H66.0307V75.0352H64.8311ZM64.8311 77.8118V80.0377H66.0307V77.8118H64.8311ZM67.7995 80.0377V77.8118H66.5998V80.0377H67.7995Z"
      fill="#73E4F9"
    />
    <path
      d="M66.5998 93.8118V91.5557H67.7995V93.8118H66.5998ZM64.8311 91.5557V93.8118H66.0307V91.5557H64.8311ZM64.8311 94.3323V96.5582H66.0307V94.3323H64.8311ZM67.7995 96.5582V94.3323H66.5998V96.5582H67.7995Z"
      fill="#73E4F9"
    />
    <path
      d="M70.8571 85.7581V83.502H72.0568V85.7581H70.8571ZM69.0884 83.502V85.7581H70.288V83.502H69.0884ZM69.0884 86.2776V88.5034H70.288V86.2776H69.0884ZM72.0568 88.5034V86.2776H70.8571V88.5034H72.0568Z"
      fill="#73E4F9"
    />
    <path
      d="M39.3701 67.4476V66.4616L39.3938 66.4378C40.0675 65.7693 41.1572 65.7801 41.8179 66.4616V67.4476H39.3701ZM39.3701 67.8083V71.2233H41.8179V67.8083H39.3701Z"
      fill="#73E4F9"
    />
    <path
      d="M39.3701 87.4554V86.4694L39.3938 86.4456C40.0675 85.7771 41.1572 85.7879 41.8179 86.4694V87.4554H39.3701ZM39.3701 87.8161V91.2311H41.8179V87.8161H39.3701Z"
      fill="#73E4F9"
    />
    <path
      d="M49.1611 67.4476V66.4616L49.1848 66.4378C49.8585 65.7693 50.9482 65.7801 51.6089 66.4616V67.4476H49.1611ZM49.1611 67.8083V71.2233H51.6089V67.8083H49.1611Z"
      fill="#73E4F9"
    />
    <path
      d="M49.1611 76.9388V75.9528L49.1848 75.929C49.8585 75.2605 50.9482 75.2713 51.6089 75.9528V76.9388H49.1611ZM49.1611 77.2995V80.7145H51.6089V77.2995H49.1611Z"
      fill="#73E4F9"
    />
    <path
      d="M44.1699 76.9388V75.9528L44.1936 75.929C44.8673 75.2605 45.957 75.2713 46.6177 75.9528V76.9388H44.1699ZM44.1699 77.2995V80.7145H46.6177V77.2995H44.1699Z"
      fill="#73E4F9"
    />
    <path
      d="M78.5748 104.312V100.909H55.9538V94.5195H26.0498V103.053C32.9698 106.153 41.4196 108 51.5744 108C61.9996 108 71.0072 106.758 78.5748 104.312Z"
      fill="#001962"
    />
    <path
      d="M107.994 61.3574C107.997 61.6061 108 61.8512 108 62.0928C108 84.9934 96.8606 99.6602 75.043 105.335V61.3574H107.994Z"
      fill="#FFA385"
    />
    <path
      d="M97.4691 65.1523H100.746V69.8352H97.4691V65.1523ZM93.5845 69.8352H96.8612V65.1523H93.5845V69.8352ZM97.4691 75.1035H100.746V70.4206H97.4691V75.1035ZM93.5845 75.1035H96.8612V70.4206H93.5845V75.1035Z"
      fill="white"
    />
    <path d="M92.8433 76.4375H101.494V74.7516H92.8433V76.4375Z" fill="#D03C0B" />
    <path
      d="M83.9183 65.1523H87.195V69.8352H83.9183V65.1523ZM80.0337 69.8352H83.3104V65.1523H80.0337V69.8352ZM83.9183 75.1035H87.195V70.4206H83.9183V75.1035ZM80.0337 75.1035H83.3104V70.4206H80.0337V75.1035Z"
      fill="white"
    />
    <path d="M79.291 76.4375H87.9419V74.7516H79.291V76.4375Z" fill="#D03C0B" />
    <path
      d="M97.4691 78.8037H100.746V83.4866H97.4691V78.8037ZM93.5845 83.4866H96.8612V78.8037H93.5845V83.4866ZM97.4691 88.7538H100.746V84.0709H97.4691V88.7538ZM93.5845 88.7538H96.8612V84.0709H93.5845V88.7538Z"
      fill="white"
    />
    <path
      d="M100.969 88.4023H92.8428V90.0882H99.7685C100.184 89.5386 100.585 88.9766 100.969 88.4023Z"
      fill="#D03C0B"
    />
    <path
      d="M83.9183 78.8037H87.195V83.4866H83.9183V78.8037ZM80.0337 83.4866H83.3104V78.8037H80.0337V83.4866ZM83.9183 88.7538H87.195V84.0709H83.9183V88.7538ZM80.0337 88.7538H83.3104V84.0709H80.0337V88.7538Z"
      fill="white"
    />
    <path d="M79.291 90.0889H87.9419V88.403H79.291V90.0889Z" fill="#D03C0B" />
    <path d="M95.7979 94.5186H93.5845L93.5845 96.4529C94.3527 95.8326 95.0905 95.1878 95.7979 94.5186Z" fill="white" />
    <path d="M87.1954 100.675V99.7868H83.9188V102.278C85.0504 101.776 86.1427 101.241 87.1954 100.675Z" fill="white" />
    <path
      d="M83.3109 102.542V99.7868H80.0342L80.0342 103.817C81.16 103.42 82.2522 102.995 83.3109 102.542Z"
      fill="white"
    />
    <path d="M87.1954 94.5186H83.9188V99.2014H87.1954V94.5186Z" fill="white" />
    <path d="M83.3109 99.2014H80.0342V94.5186H83.3109V99.2014Z" fill="white" />
    <path
      d="M107.86 57.4405H72.547L72.5459 57.4395C72.5459 58.1404 73.1129 58.7095 73.8135 58.7095H73.6572C73.6572 59.2344 74.0818 59.6599 74.6057 59.6599H107.96C107.937 58.943 107.904 58.2024 107.86 57.4405Z"
      fill="#111116"
    />
    <path d="M107.96 59.6582H75.0659V61.357H107.996C107.99 60.8074 107.978 60.2406 107.96 59.6582Z" fill="#D03C0B" />
    <path
      d="M33.0837 105.6V47.8555H1.85647C0.524773 52.2777 0 57.1239 0 62.6979C0 79.3154 9.47089 98.8866 33.0837 105.6Z"
      fill="#FFA385"
    />
    <path
      d="M10.6575 56.3333H7.38086V51.6504H10.6575V56.3333ZM14.5411 51.6504H11.2644V56.3333H14.5411V51.6504ZM10.6575 56.9186H7.38086V61.6015H10.6575V56.9186ZM14.5411 56.9186H11.2644V61.6015H14.5411V56.9186Z"
      fill="white"
    />
    <path d="M15.2842 61.249H6.6333V62.9349H15.2842V61.249Z" fill="#D03C0B" />
    <path
      d="M24.2083 56.3333H20.9316V51.6504H24.2083V56.3333ZM28.0918 51.6504H24.8152V56.3333H28.0918V51.6504ZM24.2083 56.9186H20.9316V61.6015H24.2083V56.9186ZM28.0918 56.9186H24.8152V61.6015H28.0918V56.9186Z"
      fill="white"
    />
    <path d="M28.8345 61.25H20.1836V62.9359H28.8345V61.25Z" fill="#D03C0B" />
    <path
      d="M10.6575 69.9837H7.38086V65.3008H10.6575V69.9837ZM14.5411 65.3008H11.2644V69.9837H14.5411V65.3008ZM10.6575 70.569H7.38086V75.2519H10.6575V70.569ZM14.5411 70.569H11.2644V75.2519H14.5411V70.569Z"
      fill="white"
    />
    <path d="M15.2837 74.9014H6.63281V76.5872H15.2837V74.9014Z" fill="#D03C0B" />
    <path
      d="M24.2083 69.9837H20.9316V65.3008H24.2083V69.9837ZM28.0918 65.3008H24.8152V69.9837H28.0918V65.3008ZM24.2083 70.569H20.9316V75.2519H24.2083V70.569ZM28.0918 70.569H24.8152V75.2519H28.0918V70.569Z"
      fill="white"
    />
    <path d="M28.8345 74.9014H20.1836V76.5872H28.8345V74.9014Z" fill="#D03C0B" />
    <path
      d="M10.0153 90.9667H10.6575V86.2839H7.38086V87.4073C8.18765 88.6251 9.06508 89.814 10.0153 90.9667Z"
      fill="white"
    />
    <path d="M7.38086 85.6985H10.6575V81.0156H7.38086V85.6985Z" fill="white" />
    <path d="M11.2644 81.0167H14.5411V85.6996H11.2644V81.0167Z" fill="white" />
    <path d="M11.2644 86.2839H14.5411V90.9667H11.2644V86.2839Z" fill="white" />
    <path d="M11.1636 92.3021H15.2838V90.6162H9.72949C10.1899 91.187 10.6678 91.7493 11.1636 92.3021Z" fill="#D03C0B" />
    <path
      d="M24.2083 85.6985H20.9316V81.0156H24.2083V85.6985ZM28.0918 81.0167H24.8152V85.6996H28.0918V81.0167ZM24.2083 86.2839H20.9316V90.9667H24.2083V86.2839ZM28.0918 86.2839H24.8152V90.9667H28.0918V86.2839Z"
      fill="white"
    />
    <path d="M28.8345 90.6162H20.1836V92.3021H28.8345V90.6162Z" fill="#D03C0B" />
    <path
      d="M2.41553 46.157H33.5212C34.0451 46.157 34.4697 45.7315 34.4697 45.2066H34.3135C35.013 45.2066 35.581 44.6385 35.581 43.9365L35.5799 43.9376H3.30001C2.97868 44.6668 2.68435 45.4061 2.41553 46.157Z"
      fill="#111116"
    />
    <path d="M1.85645 47.8561H33.061V46.1572H2.41555C2.21521 46.7168 2.02905 47.2829 1.85645 47.8561Z" fill="#D03C0B" />
    <path
      d="M38.9954 106.951C39.0129 106.541 39.3148 98.3474 35.5067 97.1502C31.6006 95.9223 29.2498 99.2185 29.2498 99.2185C29.2498 99.2185 31.0422 94.6641 28.5308 93.407C26.0194 92.1488 23.369 93.9589 23.369 93.9589C23.369 93.9589 21.5604 85.9463 17.6865 86.0738C13.3695 86.2161 11.4363 89.5371 10.6328 91.6988C16.9048 98.9654 26.1697 104.69 38.9954 106.951Z"
      fill="#136F65"
    />
    <path
      d="M92.6371 97.1947C91.9252 96.2093 91.1635 95.487 90.39 95.287C87.1317 94.4446 83.9779 98.1306 83.9779 98.1306C83.9779 98.1306 81.0332 94.5493 78.3008 95.0764C75.5684 95.6034 75.0424 100.027 75.0424 100.027C75.0424 100.027 73.361 98.4471 70.2072 99.0789C67.9766 99.5257 66.6928 104.311 66.1323 107.075C77.1019 105.575 85.9505 102.258 92.6371 97.1947Z"
      fill="#136F65"
    />
    <path
      d="M33.0286 17.5139C32.5134 13.924 33.8672 8.22048 39.7609 6C45.6535 3.77952 51.4815 8.15028 52.4861 12.1722C53.4895 16.1941 52.5302 22.8988 45.6999 24.6311C38.8674 26.3634 33.7648 22.6439 33.0286 17.5128V17.5139Z"
      fill="#F08B00"
    />
  </svg>
);

export const MarketDataMapSidebarEmptyStateCard = () => {
  return (
    <>
      <Paragraph>You have no properties in this area.</Paragraph>

      <Card elevated={false}>
        <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <CityscapeIllustration />

          <Heading level={5} css={{ marginBlockStart: '400', marginBlockEnd: '200' }}>
            Stay ahead of the trends with exclusive market reports
          </Heading>

          <Paragraph css={{ marginBlockEnd: '400' }}>
            A Signature package gets you access to exclusive market reports, including Moody&apos;s advanced market
            reports. Updated quarterly, these reports provide insight into rental trends like vacancies, new
            construction hot spots, and demographic shifts.
          </Paragraph>

          <TextButton textStyle="body-bold" asChild>
            <a href="https://www.zillow.com/rentals-network/packages/" target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          </TextButton>
        </Box>
      </Card>
    </>
  );
};
